import { createFileRoute, redirect } from '@tanstack/react-router'
import { parse } from 'valibot'

import { buildFetchPartnerUserQuery } from '@/features/users'
import { fetchDcUsers } from '@/features/users/api'
import { USER_ROLE } from '@/libs/api/types'
import {
  selectedDcIdAtom,
  tenantStore
} from '@/routes/_protected/$tenantKey/-states'

import { DcUsersSearchSchema } from './-models/dc-users-search'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users/'
)({
  validateSearch: (search) => parse(DcUsersSearchSchema, search),
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ search, location, context: { auth } }) => {
    // クエリの有無で初回アクセスかどうかを判定
    const keys = Object.keys(search)

    // 初回アクセス(クエリが空)の場合は、enable=true を既定付与
    // ADMIN 以外は選択中拠点(selectedDcId)も既定付与する（#3957）
    if (keys.length === 0) {
      const isAdmin = auth.user.userRole === USER_ROLE.ADMIN
      const selectedDcId = tenantStore.get(selectedDcIdAtom)
      throw redirect({
        to: location.pathname,
        search: {
          ...search,
          enable: true,
          ...(isAdmin || !selectedDcId ? {} : { dcId: selectedDcId })
        }
      })
    }
  },
  loader: async ({
    abortController,
    params: { tenantKey },
    deps,
    context: { auth }
  }) => {
    const query = buildFetchPartnerUserQuery(tenantKey, deps)

    return {
      authUser: auth.user,
      users: await fetchDcUsers(query, abortController.signal)
    }
  }
})
